import React from 'react';
import { colors, typography, spacing } from '../../../theme';

/**
 * "10 Personal Records" headline + optional "N in the last 30 days" sub-line.
 */
const RecordSummary = ({ totalPRs = 0, recentCount = 0 }) => {
  return (
    <div style={{ marginBottom: spacing.lg }}>
      <div style={{ ...typography.screenTitle, color: colors.text }}>
        {totalPRs} Personal Record{totalPRs !== 1 ? 's' : ''}
      </div>
      {recentCount > 0 && (
        <div style={{ ...typography.caption, color: colors.gold, marginTop: '4px' }}>
          {recentCount} in the last 30 days
        </div>
      )}
    </div>
  );
};

export default RecordSummary;
